import Collapse from "@material-ui/core/Collapse";
import Add from "@material-ui/icons/Add";
import * as FileSaver from "file-saver";
import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import BunchForm from "../../components/Bunch/BunchForm/BunchForm";
import Button from "../../components/UI/Button/Button";
import Input from "../../components/UI/Input/Input";
import Modal from "../../components/UI/Modal/Modal";
import LocalSearch from "../../components/UI/Search/Search";
import Spinner from "../../components/UI/Spinner/Spinner";
import Table from "../../components/UI/Table/Table";
import FetchData from "../../shared/fetchData";
import { updateObject } from "../../shared/utility";

const Bunches = (props) => {
  const [loading, setLoading] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [permission, setPermission] = useState(
    window.localStorage.getItem("permission")
  );
  const [bunches, setBunches] = useState([]);
  const [edit, setEdit] = useState(false);
  const [showBunchForm, setShowBunchForm] = useState(false);
  const [bunch, setBunch] = useState("");
  const [searchParams, setSearchParams] = useState({
    description: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نام",
      },
      validation: {
        required: true,
      },
      errorMessage: "",
      valid: true,
      value: "",
    },
  });
  const childRef = useRef();
  const [modalContent, setModalContent] = useState();

  useEffect(() => {
    setPageIndex(0);
    setPageSize(10);
    setPageCount(0);
  }, []);
  const changeStateSubmit = (id) => {
    var raw = JSON.stringify({
      bunch: {
        id: id,
      },
      version: "mtpx001",
    });
    var url = "management/api/v1/bunches/changeBunchState";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "0") {
          childRef.current.closeModal();
          search();
        }
      })
      .catch((error) => console.log(""));
  };
  const changeState = (id) => {
    setModalContent(
      <div>
        <div className="row justify-content-center">
          آیا از تغییر وضعیت مطمئن هستید؟
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-6 text-center">
            <Button btnType="Success" clicked={() => changeStateSubmit(id)}>
              بله
            </Button>
          </div>
          <div className="col-6 text-center">
            <Button
              btnType="General"
              clicked={() => {
                childRef.current.closeModal();
              }}
            >
              خیر
            </Button>
          </div>
        </div>
      </div>
    );
    childRef.current.openModal();
  };
  const finalizeBunchSubmit = (id) => {
    var raw = JSON.stringify({
      bunch: {
        id: id,
      },
      version: "mtpx001",
    });
    var url = "management/api/v1/bunches/finalizeBunch";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "0") {
          childRef.current.closeModal();
          search();
        }
      })
      .catch((error) => console.log(""));
  };
  const afterCloseModal = () => {};
  const finalizeBunch = (id) => {
    setModalContent(
      <div>
        <div className="row justify-content-center">
          آیا از نهایی کردن مطمئن هستید؟
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-6 text-center">
            <Button btnType="Success" clicked={() => finalizeBunchSubmit(id)}>
              بله
            </Button>
          </div>
          <div className="col-6 text-center">
            <Button
              btnType="General"
              clicked={() => {
                childRef.current.closeModal();
              }}
            >
              خیر
            </Button>
          </div>
        </div>
      </div>
    );
    childRef.current.openModal();
  };
  const getData = (pagination, isRefresh) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setLoading(true);
    var raw =
      !!isRefresh && isRefresh
        ? JSON.stringify({
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          })
        : JSON.stringify({
            bunch: {
              description: searchParams.description.value,
            },
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          });
    var url = "management/api/v1/bunches/getBunches";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          let newList = [];
          for (let i = 0; i < pagination.pageIndex * pagination.pageSize; i++) {
            newList.push([]);
          }
          newList = newList.concat(result.bunches);
          pushData(newList);
          setBunches(newList);
          setPageCount(result.count);
          setLoading(false);
        }
      })
      .catch((error) => console.log(error));
  };
  const pushData = (data) => {
    const rows = [];
    const headers = [
      {
        accessorKey: "identifier",
        header: "شناسه",
        align: "center",
      },
      {
        accessorKey: "description",
        header: "نام",
        align: "center",
      },
      {
        accessorKey: "isActive",
        header: "وضعیت",
        align: "center",
      },
      {
        accessorKey: "finalized",
        header: "نهایی شده",
        align: "center",
      },
      {
        accessorKey: "addressEn",
        header: "آدرس لاتین",
        align: "center",
      },
      {
        accessorKey: "city",
        header: "شهر",
        align: "center",
      },
      {
        accessorKey: "address",
        header: "آدرس",
        align: "center",
      },
    ];
    const buttons = [];
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    data.map((d) => {
      rows.push({
        id: d.id,
        identifier: d.id,
        description: d.description,
        isActive:
          d.isActive != null && d.isActive == "1" ? "فعال است" : "فعال نیست",
        finalized: d.finalized != null && d.finalized == "1" ? "بله" : "خیر",
        addressEn: d.addressEn,
        city: d.city?.description,
        address: d.address,
      });
    });
    buttons.push({ id: 1, text: "ویرایش", clicked: editBunch });
    buttons.push({ id: 2, text: "لاکرها", clicked: showKiosks });
    buttons.push({ id: 3, text: "نغییر وضعیت", clicked: changeState });
    buttons.push({ id: 4, text: "نهایی کردن", clicked: finalizeBunch });
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    setRerender(!rerender);
  };

  const exportToCSV = (event) => {
    const token = window.localStorage.getItem("token");
    var raw = JSON.stringify({
      bunch: {
        description: searchParams.description.value,
      },
      pl: "1048576",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/bunches/getBunches";
    setLoading(true);
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          let exportOrderReport = [];
          let count = 0;
          const orderReport = result.bunches.map((o) => {
            count++;
            exportOrderReport.push({
              ردیف: count,
              شناسه: o.id,
              نام: o.description,
              "آدرس لاتین": o.addressEn,
              "طول جغرافیایی": o.lon,
              "عرض جغرافیایی": o.lat,
              آدرس: o.address,
              وضعیت:
                o.isActive != null && o.isActive == "1"
                  ? "فعال است"
                  : "فعال نیست",
              "نهایی شده":
                o.finalized != null && o.finalized == "1" ? "بله" : "خیر",
            });
          });
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          const fileExtension = ".xlsx";
          const ws = XLSX.utils.json_to_sheet(exportOrderReport);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, "data" + fileExtension);
        }
      })
      .catch((error) => setLoading(false));
  };
  const search = (event) => {
    getData({ pageIndex: pageIndex, pageSize: pageSize });
  };

  const refresh = (event) => {
    const srch = searchParams;
    for (let key in srch) {
      srch[key].value = "";
    }
    setSearchParams(srch);
    getData({ pageIndex: pageIndex, pageSize: pageSize }, true);
  };

  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(searchParams, {
      [controlName]: updateObject(searchParams[controlName], {
        value: event.target.value,
      }),
    });
    setSearchParams(updatedControls);
  };

  const addNewBunch = () => {
    setEdit(false);
    setShowBunchForm(true);
  };

  const showKiosks = (id, data) => {
    const item = data.filter((d) => d.id === id);
    if (!!item && item.length > 0) {
      setModalContent(
        <div className="row justify-content-center w-100">
          {item[0].kiosks?.map((k) => {
            return (
              <div className="row justify-content-center w-100 mt-2">
                <div className="kiosk-row p-2">
                  <div className="row">
                    <div className="col-4">نام لاکر: {k.description}</div>
                    <div className="col-8">آدرس: {k.address}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
      childRef.current.openModal();
    }
  };

  const editBunch = (id, data) => {
    const bnch = data.filter((b) => b.id === id);
    if (!!bnch && bnch.length > 0) {
      setBunch(bnch[0]);
      setEdit(true);
      setShowBunchForm(true);
    }
  };

  const formElementsArray = [];
  for (let key in searchParams) {
    formElementsArray.push({
      id: key,
      config: searchParams[key],
    });
  }
  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        search={true}
        col="3 mt-2"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });
  form = (
    <div>
      <div className="row pl-4" dir="ltr" style={{ height: "0px" }}>
        <Button btnType="Refresh" clicked={refresh}></Button>
      </div>
      <div className="row mt-4">{form}</div>
      <div className="row text-left" dir="ltr">
        <div className="col-2">
          <Button btnType="search-btn" clicked={search}>
            جستجو
          </Button>
        </div>
        <div className="col-2 text-left ord-small-btns">
          <Button btnType="Search" clicked={exportToCSV}>
            <span className="tab-color">گزارشگیری</span>
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {loading ? <Spinner /> : ""}
      <Collapse in={!showBunchForm}>
        <LocalSearch class="orders-search" form={form} />
        {permission != null && permission.includes("BUNCH_WRITE") ? (
          <div className="row justify-content-center mt-3 ml-3">
            <div className="UserGeneralBtn mb-2">
              <div onClick={(event) => addNewBunch(event)} className="Add">
                <Add className="UserIcon" />
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {rerender ? (
          // <Spinner />
          <Table
            hasDetails={false}
            data={bunches}
            pageSize={pageSize}
            pageIndex={pageIndex}
            getData={getData}
            list={tableData}
            rowCount={pageCount}
            columnSize={170}
            loading={loading}
          />
        ) : (
          <Table
            hasDetails={false}
            data={bunches}
            pageSize={pageSize}
            pageIndex={pageIndex}
            getData={getData}
            list={tableData}
            rowCount={pageCount}
            columnSize={170}
            loading={loading}
          />
        )}
      </Collapse>
      <Collapse in={showBunchForm}>
        {showBunchForm ? (
          <BunchForm
            bunch={bunch}
            edit={edit}
            toggleNewBunchForm={(event, value) => {
              setShowBunchForm(value);
            }}
            toggleNewBunchFormAndReload={(event, value) => {
              search();
              setShowBunchForm(value);
            }}
          />
        ) : (
          ""
        )}
      </Collapse>
      <Modal
        content={modalContent}
        ref={childRef}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
    </>
  );
};
export default Bunches;
